import * as z from "zod";

/**
 * The page a user last read in a document, or `null` when they never opened it.
 *
 * @public
 */
export const DocumentProgressSchema = z
	.object({
		page: z.number().int().positive().nullable(),
	})
	.meta({
		title: "DocumentProgress",
		description: "Page a user last read in a document.",
		examples: [{ page: 12 }, { page: null }],
	});

export type DocumentProgress = z.infer<typeof DocumentProgressSchema>;

/**
 * @public
 */
export const UpdateDocumentProgressDtoSchema = z
	.object({
		page: z.number().int().positive(),
	})
	.meta({
		title: "UpdateDocumentProgressDto",
		description: "Page the user navigated to.",
		examples: [{ page: 12 }],
	});

export type UpdateDocumentProgressDto = z.infer<
	typeof UpdateDocumentProgressDtoSchema
>;

/**
 * @public
 */
export const StoredDocumentProgressSchema = z
	.object({
		documentId: z.string(),
		page: z.number().int().positive(),
	})
	.meta({
		title: "StoredDocumentProgress",
		description: "Progress as it was persisted.",
		examples: [{ documentId: "05RlueqwxaR5srvOyO3Q", page: 12 }],
	});

export type StoredDocumentProgress = z.infer<
	typeof StoredDocumentProgressSchema
>;
